import { FC } from 'react';
import { themeColors, themeSizes } from '../../../styles/globalStyleVars';
import { IconChevronRight, IconCircleCheck } from '@tabler/icons-react';
import styled from 'styled-components';
import { TypographyStyled } from '../../Styled/Typography';

export interface Props {
  setShowExpiredAlerts: (val: boolean) => void;
}

const ExpiredLinkLeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ExpiredLinkAction = styled(TypographyStyled)`
  border: 1px solid transparent;
  border-radius: ${themeSizes.sm};
  background: transparent;
  padding: 0 ${themeSizes.sm};
  display: flex;
  align-items: center;
  color: ${themeColors.secondaryBlue};
  font-weight: 500;
  transition: color 0.15s ease-in-out;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    border-color: ${themeColors.focus};
  }
`;

const ExpiredLinkWrapper = styled.div`
  border-radius: ${themeSizes.sm};
  background-color: ${themeColors.notificationBackgroundColor};
  width: 100%;
  padding: ${themeSizes.md} ${themeSizes.lg};
  margin-bottom: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: default;

  &:hover ${ExpiredLinkAction} {
    color: ${themeColors.secondaryBlueHover};
  }

  &:active ${ExpiredLinkAction} {
    color: ${themeColors.secondaryBluePressed};
  }
`;

export const ExpiredLink: FC<Props> = ({ setShowExpiredAlerts }) => {
  return (
    <ExpiredLinkWrapper
      onClick={() => setShowExpiredAlerts(true)}
      data-testid='expired-alerts-see-all-button'
    >
      <ExpiredLinkLeftContent>
        <IconCircleCheck
          size={themeSizes.lg}
          color={themeColors.colorGray_8}
          aria-hidden='true'
          focusable='false'
        />
        <TypographyStyled
          text='Expired Alerts & Outages'
          color={themeColors.colorGray_8}
          fontWeight='bold'
        />
      </ExpiredLinkLeftContent>
      <ExpiredLinkAction
        as='button'
        type='button'
        onClick={e => {
          e.stopPropagation();
          setShowExpiredAlerts(true);
        }}
      >
        See all
        <IconChevronRight size={20} style={{ marginLeft: themeSizes.xs }} />
      </ExpiredLinkAction>
    </ExpiredLinkWrapper>
  );
};
